/**
 * Desktop chrome for the player-count editor (W5). The body is shared with the
 * phone sheet — see `components/PlayerCountEditor.tsx` for what it does and why
 * the copy differs from the design's.
 *
 * 440px, against the seven widths §4 documents. Those describe the panels in use
 * rather than an allowed set, and every one of them is sized for a list or a
 * detail pane; this is a two-field form with one button, and 520 would leave the
 * inputs floating in a box built for something else.
 */

import { useQd } from '../../store/index.ts';
import { PlayerCountEditor } from '../../components/PlayerCountEditor.tsx';
import { Modal } from '../components/Modal.tsx';

export default function PlayerCountModal(): JSX.Element | null {
  const s = useQd();
  const g = s.gById(s.capOpen);
  if (!s.capOpen || !g) return null;
  return (
    <Modal
      width={440}
      label="Player count"
      onClose={() => s.closeCap()}
      header={{ title: 'PLAYER COUNT', note: g.n.toUpperCase() }}
    >
      <PlayerCountEditor />
    </Modal>
  );
}
